import React, { useState, useEffect, useRef } from "react";
import Modal from "@mui/material/Modal";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import StudentProgress from "../ProgressBar/StudentProgress";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@mui/material";
import Slide from "@mui/material/Slide";

const LeaderBoardModal = (props) => {
  // Hooks
  const containerRef = useRef();
  const styles = useStyles();

  return (
    <Modal
      open={props.show}
      onClose={() => {
        if (!props.persistent) {
          props.toggleModal(false);
        }
      }}
      ref={containerRef}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Slide direction="up" in={props.show} container={containerRef.current}>
        <Grid
          container
          className={styles.Modal}
          sx={{
            backgroundColor: "#F5F7FF",
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
          }}
        >
          <Grid
            xs={12}
            sx={{
              backgroundColor: "primary.main",
              p: 2,
              pl: 3,
              borderTopLeftRadius: 30,
              borderTopRightRadius: 30,
            }}
          >
            <Typography
              sx={{
                fontSize: "1.4rem",
                fontWeight: "900",
                "@media (min-width: 1636px)": {
                  fontSize: "2rem",
                },
              }}
            >
              Leader Board
            </Typography>
          </Grid>
          <Grid
            xs={12}
            sx={{
              flexDirection: "row",
              justifyContent: "flex-start",
              mt: 1,
              pl: 2,
            }}
          >
            <Grid item sx={{}}>
              <Box
                className={styles.scrollBarHeight}
                sx={{
                  pl: 4,
                  pr: 4,
                  py: 2,
                  height: "67vh",
                  overflow: "auto",
                  mb: 1,
                  mr: 2,
                }}
              >
                {props.leaderBoardData &&
                  props.leaderBoardData.map((data, index) => {
                    return (
                      <StudentProgress
                        key={`leader_board_${index}`}
                        data={data}
                        classes={props.classes}
                        index={index}
                        isRank={true}
                        isCupDisplay={data.percentage <= 0 ? false : true}
                      />
                    );
                  })}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Slide>
    </Modal>
  );
};
const useStyles = makeStyles({
  Modal: {
    width: "60%",
    backgroundColor: "#F5F7FF",
    boxShadow: 24,
    color: "#FFFFFF",
    borderRadius: 30,
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      width: "0.0em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default LeaderBoardModal;
